import { ComponentProps } from 'react';
import { useFormContext } from 'react-hook-form';
import { PhoneInput } from '../components';
import { FormField } from './BaseFormComponents';
import { BaseFormFieldWrapper } from './BaseFormFieldWrapper';
import { FormComponentBaseProps } from './types/form-base-props';

export type FormPhoneInputProps = Omit<
  FormComponentBaseProps & ComponentProps<typeof PhoneInput>,
  'onChange'
>;

const FormPhoneInput = ({
  description,
  descriptionProps,
  label,
  labelProps,
  hideError,
  defaultValue,
  name,
  disabled,
  ...props
}: FormPhoneInputProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      shouldUnregister={false}
      disabled={disabled}
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <BaseFormFieldWrapper
          description={description}
          descriptionProps={descriptionProps}
          label={label}
          labelProps={labelProps}
          hideError={hideError}
        >
          <PhoneInput {...field} {...props} disabled={disabled} />
        </BaseFormFieldWrapper>
      )}
    />
  );
};

export { FormPhoneInput };
